import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FileUploader } from './file-uploader';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[ng2FileDrop]',
    standalone: false
})
export class FileDropDirective {
  @Input() public uploader: FileUploader;
  @Output() public fileOver: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public onFileDrop: EventEmitter<File[]> = new EventEmitter<File[]>();

  constructor(private element: ElementRef) {}

  @HostListener('drop', ['$event'])
  public onDrop(event: DragEvent): void {
    const files = this._extractFiles(event);
    event.preventDefault();
    event.stopPropagation();
    this.fileOver.emit(false);
    if (!files.length) { return; }
    if (this.uploader) {
      this.uploader.addToQueue(files);
    }
    this.onFileDrop.emit(files);
  }

  @HostListener('dragover', ['$event'])
  public onDragOver(event: DragEvent): void {
    if (this._hasFiles(event)) {
      this.fileOver.emit(true);
      this._setDropEffect(event, 'copy');
      event.preventDefault();
      event.stopPropagation();
    }
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(event: DragEvent): void {
    if (event.currentTarget === this.element.nativeElement) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.fileOver.emit(false);
  }

  private _extractFiles(event: DragEvent): File[] {
    const transfer = event.dataTransfer;
    if (!transfer) { return []; }
    if (transfer.items && transfer.items.length) {
      const out: File[] = [];
      for (let i = 0; i < transfer.items.length; i++) {
        const item = transfer.items[i];
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file) { out.push(file); }
        }
      }
      if (out.length) { return out; }
    }
    if (transfer.files && transfer.files.length) {
      return Array.from(transfer.files);
    }
    return [];
  }

  private _hasFiles(event: DragEvent): boolean {
    const types = event.dataTransfer?.types;
    if (!types) { return false; }
    for (let i = 0; i < types.length; i++) {
      if (types[i] === 'Files' || types[i] === 'application/x-moz-file') { return true; }
    }
    return false;
  }

  private _setDropEffect(event: DragEvent, effect: 'none' | 'copy' | 'link' | 'move'): void {
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = effect;
    }
  }
}
